import React, { useContext } from 'react';

import { PagePropsContext } from '../App';
import Header from '../components/Header';
import Footer from '../components/Footer';

import Question from '../components/Question';
import Permalink from '../components/Permalink';

const PageQuestion = () => {
  const { categories, selectedQuestion, setSelectedQuestion } = useContext(PagePropsContext);
  const category = categories.find(c => c.id === selectedQuestion.category);

  return <div className='page page--question'>
    <Header
      title={category.name}
      showBreadcrumb={true}
      onBack={() => setSelectedQuestion(null)}
    />
    <div className='page__content page--question'>
      <Question question={selectedQuestion} />
      <Permalink question={selectedQuestion} />
    </div>
    <Footer />
  </div>;
}

export default PageQuestion;